import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { Model } from 'app/model/backendmodel';
import { GenericCDataLinkedService } from 'shell-models-lib';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(GenericCDataLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*'
        }
    }
})
export class GenericCDataLinkedServiceAdapter extends LinkedServiceAdapter<GenericCDataLinkedService> {
    protected modelConstructor(): new () => GenericCDataLinkedService {
        return GenericCDataLinkedService;
    }

    protected model(): IModel {
        return GenericCDataLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(
        _linkedService: GenericCDataLinkedService,
        linkedServiceResource: Model.LinkedServiceResource
    ): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.GenericCDataLinkedService;
        properties.type = Metamodel.modelFor(GenericCDataLinkedService).name;
        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(
        _linkedServiceResource: Model.LinkedServiceResource,
        linkedService: GenericCDataLinkedService
    ): Promise<GenericCDataLinkedService> {
        return linkedService;
    }
}
